import { render, staticRenderFns } from "./PackagingSnapshot.vue?vue&type=template&id=36e040a8"
import script from "./PackagingSnapshot.vue?vue&type=script&lang=js"
export * from "./PackagingSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e040a8')) {
      api.createRecord('36e040a8', component.options)
    } else {
      api.reload('36e040a8', component.options)
    }
    module.hot.accept("./PackagingSnapshot.vue?vue&type=template&id=36e040a8", function () {
      api.rerender('36e040a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/PackagingSnapshot.vue"
export default component.exports